define( [
	"./class2type"
], function( class2type ) {
	"use strict";

	return class2type.toString;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/toString.js
// module id = 9G4n
// module chunks = 0 1